.flooring-guide-page {
  --content-max: 1500px;
  --container-pad: clamp(16px, 4vw, 48px);
  --tap-min: 44px;
  --section-gap: clamp(32px, 6vw, 120px);

  .page {
    width: 100%;
    min-height: 100%;
    height: auto;
    overflow: visible;
    position: relative;
    background-color: rgba(255, 255, 255, 1);
  }

  // ---------------------------------------------------------------------------
  // Hero
  // ---------------------------------------------------------------------------
  .guide-hero {
    position: relative;
    width: 100%;
    min-height: clamp(620px, 78vh, 920px);
    background: url(../../../assets/images/pages-products-products-hero.png) no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
  }

  .guide-hero__overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(22, 0, 4, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  // ---------------------------------------------------------------------------
  // Main
  // ---------------------------------------------------------------------------
  .guide-main {
    width: 100%;
  }

  .guide-intro {
    width: 100%;
    max-width: var(--content-max);
    margin: var(--section-gap) auto 0;
    padding-inline: var(--container-pad);
    box-sizing: border-box;
    text-align: center;
  }

  .guide-intro__eyebrow {
    margin: 0;
    color: rgba(163, 135, 95, 1);
    font-size: clamp(14px, 1.2vw, 18px);
    font-family: Red Rose-Medium;
    font-weight: normal;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    text-align: center;
  }

  .guide-intro__title {
    margin: clamp(10px, 1.6vw, 18px) 0 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(40px, 6vw, 80px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    text-transform: uppercase;
    line-height: 1;
    white-space: normal;
  }

  .guide-intro__lead {
    margin: clamp(18px, 3.5vw, 40px) auto 0;
    max-width: min(92ch, 100%);
    color: rgba(124, 124, 124, 1);
    font-size: clamp(16px, 1.6vw, 24px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    line-height: 1.6;
  }

  // ---------------------------------------------------------------------------
  // Featured article
  // ---------------------------------------------------------------------------
  .guide-featured {
    width: 100%;
    max-width: var(--content-max);
    margin: clamp(40px, 6vw, 120px) auto 0;
    padding-inline: var(--container-pad);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: clamp(32px, 5vw, 96px);
  }

  .guide-featured__text {
    flex: 1 1 0;
    min-width: 0;
  }

  .guide-featured__title {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(28px, 3.2vw, 44px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: left;
    text-transform: none;
    line-height: 1.15;
    white-space: normal;
  }

  .guide-featured__excerpt {
    margin: clamp(16px, 2.4vw, 28px) 0 0;
    color: rgba(124, 124, 124, 1);
    font-size: clamp(15px, 1.2vw, 18px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: left;
    line-height: 1.7;
  }

  .guide-featured__cta {
    margin-top: clamp(24px, 3vw, 36px);
    width: fit-content;
    min-height: 50px;
    padding: clamp(10px, 1.05vw, 14px) clamp(24px, 2.4vw, 32px);
    border-radius: 10px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: inherit;
    transition:
      background-color 0.2s ease,
      transform 0.2s ease,
      border-color 0.2s ease;
    background-color: transparent;
    border: 2px solid rgba(22, 0, 4, 1);

    &:hover {
      transform: translateY(-1px);
      background-color: rgba(22, 0, 4, 1);
      border-color: rgba(22, 0, 4, 1);

      .guide-featured__ctaLabel {
        color: rgba(255, 255, 255, 1);
      }
    }

    &:active {
      transform: translateY(0);
    }
  }

  .guide-featured__ctaLabel {
    font-size: clamp(16px, 1.05vw, 20px);
    font-family: Red Rose-Medium;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;
    color: rgba(22, 0, 4, 1);
    transition: color 0.2s ease;
  }

  .guide-featured__media {
    flex: 1.3 1 0;
    min-width: 0;
  }

  .guide-featured__image {
    width: 100%;
    height: clamp(320px, 34vw, 520px);
    object-fit: cover;
    border-radius: 24px;
    display: block;
  }

  // ---------------------------------------------------------------------------
  // More / cross-links
  // ---------------------------------------------------------------------------
  .guide-more {
    width: 100%;
    max-width: var(--content-max);
    margin: clamp(64px, 10vw, 180px) auto 0;
    padding-inline: var(--container-pad);
    box-sizing: border-box;
    text-align: center;
  }

  .guide-more__title {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(32px, 4.4vw, 56px);
    font-family: Red Rose-Medium;
    font-weight: normal;
    text-align: center;
    text-transform: uppercase;
    line-height: 1.1;
    white-space: normal;
  }

  .guide-more__text {
    margin: clamp(16px, 3.5vw, 40px) auto 0;
    max-width: min(92ch, 100%);
    color: rgba(124, 124, 124, 1);
    font-size: clamp(16px, 1.6vw, 24px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    line-height: 1.7;
  }

  // ---------------------------------------------------------------------------
  // Breakpoints
  // ---------------------------------------------------------------------------
  @media (max-width: 1023px) {
    .guide-featured {
      flex-direction: column;
      align-items: stretch;
    }

    .guide-featured__title,
    .guide-featured__excerpt {
      text-align: center;
    }

    .guide-featured__cta {
      margin-left: auto;
      margin-right: auto;
    }

    .guide-featured__image {
      border-radius: 16px;
    }
  }

  @media (max-width: 767px) {
    .guide-hero {
      min-height: clamp(220px, 30vh, 340px);
    }

    .guide-featured__cta {
      width: 100%;
    }
  }
}
